import { UserService } from '@/services';
import { User } from '@/types';
import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

export const useUserStore = defineStore('users', () => {
    const users = ref<Record<string, User>>({});
    const fetchingIds = ref<Set<string>>(new Set());

    const find = computed(() => {
        return (id: string) => {
            if (users.value[id]) {
                return users.value[id];
            }

            if (!fetchingIds.value.has(id)) {
                fetch(id);
            }

            return null;
        };
    });

    const fetch = async (id: string) => {
        if (fetchingIds.value.has(id)) return;

        fetchingIds.value.add(id);
        try {
            const result = await UserService.get(id);
            users.value[id] = result;
            return result;
        } finally {
            fetchingIds.value.delete(id);
        }
    };

    return { find, fetch, users: computed(() => users.value) };
});
